import {pxToEm} from "utils/styles/style_helpers";



export default theme =>({
    directDeposit:{
        '& .griditem': {
            maxWidth: pxToEm(310),
            width: '100%',
            marginRight: pxToEm(30),
            marginTop: pxToEm(20),
            '& .field':{
                maxWidth: pxToEm(310),
                width: '100%'
            }
        }
    }
})